import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20background%20with%20subtle%20flowing%20shapes%20reminiscent%20of%20anime%20speed%20lines%20and%20manga%20tone%20patterns%2C%20deep%20dark%20navy%20and%20crimson%20color%20tones%2C%20dramatic%20atmospheric%20texture%2C%20modern%20composition%20with%20dark%20aesthetic%20elements%20and%20warm%20red%20accent%20lights&width=1920&height=600&seq=cta-bg-manga-02-dark&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/40 via-transparent to-accent-950/20"></div>
      </div>

      <div className="relative z-10 max-w-screen-lg mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          {t('home.cta.title')}
        </h2>
        <p className="text-sm md:text-base text-background-200/60 max-w-xl mx-auto mb-8">
          {t('home.cta.subtitle')}
        </p>
        <Link
          to="/about"
          className="inline-flex px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer"
        >
          {t('home.cta.button')}
        </Link>
      </div>
    </section>
  );
}